import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import CaptionTypography from 'components/CaptionTypography';
import ResponsiveImg from 'components/ResponsiveImg';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import WindowCloseIcon from 'mdi-material-ui/WindowClose';

const SimpleDialogActions = styled(DialogActions)`
  margin-bottom: -18px;
  z-index: 30;
`;

const DialogImg = styled.img`
  max-width: 100%;
  margin: 0 auto;
`;

const CenteredDialogContent = styled(DialogContent)`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 780px) {
    padding: 0;
  }
`;

const ResponsiveFigure = styled(ResponsiveImg)`
  margin-bottom: 1em;
`;

const FigureWrapper = styled.div`
  float: ${props => props.align !== 'center' && props.align};
  width: ${props =>
    !props.align || props.align === 'center' ? '100%' : 'auto'};
  padding-bottom: 18px;
  padding-top: 18px;
  padding-right: ${props => (props.align === 'left' ? '18px' : '0')};
  padding-left: ${props => (props.align === 'right' ? '18px' : '0')};
  text-align: ${props => (props.align === 'center' ? props.align : 'left')};

  ${props =>
    props.maxLayoutWidth &&
    css`
      max-width: ${props.maxLayoutWidth}px;
      margin-left: auto;
      margin-right: auto;
    `}

  @media (max-width: 640px) {
    float: none;
    margin-right: auto;
    margin-left: auto;
  }
`;

const FigurePlaceholderWrapper = styled.div`
  margin-bottom: 1em;

  ${props =>
    props.dimension?.width &&
    props.dimension?.height &&
    css`
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: ${props =>
        (props.dimension.height / props.dimension.width) * 100}%;
    `}
`;

const FigureModal = ({ children, image, caption, enable }) => {
  const [open, setOpen] = useState(false);
  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return enable ? (
    <>
      <div onClick={handleClickOpen}>{children}</div>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        fullScreen={window.innerWidth < 780}
      >
        <SimpleDialogActions>
          <IconButton onClick={handleClose}>
            <WindowCloseIcon />
          </IconButton>
        </SimpleDialogActions>{' '}
        <CenteredDialogContent>
          <TransformWrapper centerOnInit={true}>
            <TransformComponent
              wrapperStyle={{ width: '100%', height: '100%' }}
              contentStyle={{ width: 'auto', height: 'auto' }}
            >
              <FigurePlaceholderWrapper dimension={image.dimension}>
                <DialogImg
                  src={`${image.url}?format=pjpg&width=1920&auto=webp&disable=upscale`}
                />
              </FigurePlaceholderWrapper>
            </TransformComponent>
          </TransformWrapper>
        </CenteredDialogContent>
        {caption && (
          <DialogContent>
            <CaptionTypography variant="caption">{caption}</CaptionTypography>
          </DialogContent>
        )}
      </Dialog>
    </>
  ) : (
    children
  );
};

const Figure = ({
  image,
  caption,
  align,
  maxLayoutWidth,
  responsiveImgProps,
  enableModal = image?.dimension?.width > 780,
  ...other
}) => {
  return image && image.url ? (
    <FigureModal enable={enableModal} image={image} caption={caption}>
      <FigureWrapper align={align} maxLayoutWidth={maxLayoutWidth} {...other}>
        <FigurePlaceholderWrapper dimension={image.dimension}>
          <ResponsiveFigure
            src={image.url}
            disableUpscale
            maxWidth={maxLayoutWidth}
            {...responsiveImgProps}
          />
        </FigurePlaceholderWrapper>
        {caption && (
          <CaptionTypography variant="caption">{caption}</CaptionTypography>
        )}
      </FigureWrapper>
    </FigureModal>
  ) : null;
};

export default Figure;
